import "../../variables.module.css";

import { Box } from "@dropbox/dig-foundations";
import { AiChatLine, EditLine, StacksLine } from "@dropbox/dig-icons/assets";
import { ScopedModeChip } from "@mirage/mosaics/Omnibox/components/Omnibar/ScopedButtonRow/ScopedModeChip";
import { typeahead } from "@mirage/service-typeahead-search/service/types";
import i18n from "@mirage/translations";
import classNames from "classnames";
import styles from "./ScopedButtonRow.module.css";

import { ModeAtom } from "@mirage/mosaics/Omnibox/atoms/mode";
import type { ScopedModeChipProps } from "@mirage/mosaics/Omnibox/components/Omnibar/ScopedButtonRow/ScopedModeChip";
import { useOmniboxMotionFlag } from "@mirage/mosaics/Omnibox/hooks/useOmniboxMotion";
import { LottieAnimationType } from "@mirage/shared/lottie-animations/LottieAnimation";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import { useAtomValue } from "jotai";

type ScopedButtonRowProps = {
  onAttachButtonClicked: () => void;
  onScopedButtonClicked: (mode: typeahead.Mode) => void;
  isTypeaheadOpen: boolean;
};

const getScopedModeChips = (): Omit<
  ScopedModeChipProps,
  "onClickHandler" | "isSelected"
>[] => [
  {
    src: AiChatLine,
    lottieAnimationType: LottieAnimationType.CHAT,
    chipOmniboxScopedMode: typeahead.Mode.Ask,
    chipLabel: i18n.t("omnibox_chip_ask"),
  },
  {
    src: EditLine,
    lottieAnimationType: LottieAnimationType.EDIT_PDF,
    chipOmniboxScopedMode: typeahead.Mode.Write,
    chipLabel: i18n.t("omnibox_chip_write"),
  },
  {
    src: StacksLine,
    lottieAnimationType: LottieAnimationType.ORGANIZE,
    chipOmniboxScopedMode: typeahead.Mode.Organize,
    chipLabel: i18n.t("omnibox_chip_organize"),
  },
];

export const ScopedButtonRow = ({
  onScopedButtonClicked,
  // onAttachButtonClicked,
  isTypeaheadOpen,
}: ScopedButtonRowProps) => {
  const omniboxScopedMode = useAtomValue(ModeAtom);
  const isMobile = useIsMobileSize();
  const { getMotionVersionFor } = useOmniboxMotionFlag();
  const expandMotionVariant = getMotionVersionFor("expand");

  return (
    <Box
      className={classNames(styles.scopedButtonsBoxRow, {
        [styles.isTypeaheadOpen]: isTypeaheadOpen,
        [styles.mobile]: isMobile,
        [styles.isExpandMotionV1]: expandMotionVariant === "V1",
      })}
    >
      {/* OSE-5161 */}
      {/*<IconButton*/}
      {/*  variant="opacity"*/}
      {/*  shape="circular"*/}
      {/*  onClick={onAttachButtonClicked}*/}
      {/*  // TEMP disable this until we have functionality for attachements*/}
      {/*  disabled={true || disableButtonRow}*/}
      {/*>*/}
      {/*  /!* TODO: OSE-5085 add tooltip & a11y label*!/*/}
      {/*  <UIIcon src={AddLine} aria-label="attach a document" />*/}
      {/*</IconButton>*/}

      {getScopedModeChips().map(
        ({ src, chipOmniboxScopedMode, chipLabel, lottieAnimationType }) => (
          <ScopedModeChip
            key={chipOmniboxScopedMode}
            src={src}
            lottieAnimationType={lottieAnimationType}
            chipOmniboxScopedMode={chipOmniboxScopedMode}
            chipLabel={chipLabel}
            onClickHandler={() => onScopedButtonClicked(chipOmniboxScopedMode)}
            disabled={isTypeaheadOpen}
            isSelected={chipOmniboxScopedMode === omniboxScopedMode}
          />
        ),
      )}
    </Box>
  );
};
